import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-page',
  imports: [],
  templateUrl: './empty-page.html',
  styleUrl: './empty-page.scss'
})
export class EmptyPage {

}
